import React, { useState } from 'react';
import Box from '@mui/material/Box';
import MissionItem from '../components/MissionItem';
import id1 from "../assets/id1.png";
import id2 from "../assets/id2.png";
import id3 from "../assets/id3.png";
import { useTranslation } from 'react-i18next';

const MissionList = () => {
  const [selectedMission, setSelectedMission] = useState(null);
  const { t } = useTranslation();

  const missions = [
    {
      id: 1,
      title: t('mission.card1Title'),
      description: t('mission.card1Desc'),
      image: id1,
    },
    {
      id: 2,
      title: t('mission.card2Title'),
      description: t('mission.card2Desc'),
      image: id2,
    },
    {
      id: 3,
      title: t('mission.card3Title'),
      description: t('mission.card3Desc'),
      image: id3,
    },
  ];

  return (
    <Box
      sx={{
        width: '100%',
        maxWidth: 1000,
        margin: '0 auto',
        display: 'grid',
        gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))',
        gap: 3,
        justifyItems: 'center',
      }}
    >
      {missions.map((mission, index) => (
        <MissionItem
          key={mission.id}
          title={mission.title}
          description={mission.description}
          image={mission.image}
          isSelected={selectedMission === index}
          onClick={() => setSelectedMission(index)}
        />
      ))}
    </Box>
  );
};

export default MissionList;